import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';
import { Grid, Button, IconButton } from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    //padding: theme.spacing(1),
    alignItems: 'center',
    minHeight: 'fit-content',
    paddingBottom: theme.spacing(1)
  },
  // avatar: {
  //   width: 60,
  //   height: 60
  // },
  name: {
    marginTop: theme.spacing(1)
  },
  logout_button: {
    marginTop: theme.spacing(1)
  }
}));

const Profile = props => {
  const { className, isDesktop, onClickLogout, ...rest } = props;

  const classes = useStyles();

  // const user = {
  //   name: 'Shen Zhi',
  //   avatar: '/images/avatars/avatar_11.png',
  //   bio: 'Brain Director'
  // };

  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);

  const [date_time, set_date_time] = useState(new Date());

  let intervalID;

  const tick = () => {
      set_date_time(new Date());
    // this.setState({
    //   date: new Date().toLocaleString()
    // });
  }

  useEffect(() => {

    const jwt = localStorage.getItem('jwt');
    if (jwt) {
      const decoded = jwtDecode(jwt);

      if (decoded.userid !== null) {
        setUserId(decoded.userid);
      }
      if (decoded.name !== null) {
        setUserName(decoded.name);
      }
    }

    intervalID = setInterval(
      () => tick(),
      1000
    );

    return () => {
      clearInterval(intervalID);
      //console.log("componentDidUnmount");
    };

  }, []);

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      {/* <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={user.avatar}
        to="/settings"
      /> */}
      <Typography
        className={classes.name}
        variant="h4"
      >
        {`${userName}님`}
      </Typography>
      <Typography variant="body2">안녕하세요.</Typography>
      {/* <Typography variant="body2">{user.bio}</Typography> */}
      <Typography variant="body1">{date_time.toLocaleDateString()}</Typography>
      {/* <Typography variant="body1">{date_time.toLocaleTimeString()}</Typography> */}
      <Typography variant="body1">{moment(date_time).format('HH:mm:ss')}</Typography>
      {isDesktop === false && (
        <Grid container justify="flex-end">
          {/* <IconButton
            //className={classes.signOutButton}
            color="inherit"
            onClick={onClickLogout}
          >
            <InputIcon />
          </IconButton> */}
          <Button
            //variant="contained"
            //</Grid>color="primary"
            className={classes.logout_button}
            endIcon={<InputIcon />}
            onClick={onClickLogout}
          >
            로그아웃 
          </Button>
        </Grid>
      )}
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
